import { Component, OnInit } from '@angular/core';
import { ObjectFieldService } from '../object-field.service';
import { ObjectField } from '../../models/project';
import { ModalService } from '../../core/modal.service';
import { EditObjectFieldComponent } from './edit-object-field/edit-object-field.component';

@Component({
  selector: 'cw-object-fields',
  templateUrl: './object-fields.component.html',
  styleUrls: ['./object-fields.component.scss']
})
export class ObjectFieldsComponent implements OnInit {
  fields: ObjectField[];

  constructor(private fieldService: ObjectFieldService,
              private modal: ModalService) {
  }

  ngOnInit() {
    this.loadFields();
  }

  createField() {
    const modalRef = this.modal.open(EditObjectFieldComponent);
    modalRef.componentInstance.ngOnInit();
    modalRef.result.then(field => {
      this.loadFields();
    });
  }

  editField(field: ObjectField) {
    const modalRef = this.modal.open(EditObjectFieldComponent);
    modalRef.componentInstance.ngOnInit(field);
    modalRef.result.then(field => {
      this.loadFields();
    });
  }

  deleteField(field: ObjectField) {
    if (!confirm('Ta bort fältet?')) {
      return;
    }

    this.fieldService.destroy(field).subscribe(() => this.loadFields());
  }

  private loadFields() {
    this.fieldService.get().subscribe(fields => {
      this.fields = fields;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/object-fields/object-fields.component.ts